/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Mariano Lopez China Santiago <s_lopezchinam@globalhitss.com>, December 2020
 */
import React from 'react';
import cls from '../utils/classnames';
import './_styles.scss';
import {
    PLAN_SELECTOR,
    PLAN_SELECTOR_ITEM,
    PLAN_SELECTOR_ITEM_CARD,
    PLAN_SELECTOR_ITEM_MORE_INFO,
    PLAN_SELECTOR_ITEM_MORE_INFO_TAB,
    PLAN_SELECTOR_ITEM_MORE_INFO_TAB_ACTIVE,
    PLAN_SELECTOR_ITEM_MORE_INFO_TAB_DEACTIVATE,
    PLAN_SELECTOR_ITEM_CARD_CONTENT,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_PROVIDER_LOGO,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PRICE_FREQUENCY,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PRICE,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PERIODICITY,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_TAX,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_PROMOTION1,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_PROMOTION2,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_PROMOTION3,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_CURRRENCY,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PRICE_TAXES,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_IN_MODAL_ADD_ON,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_PROMOTION_IN_MODAL_ADD_ON
} from '../utils/classes';
import { MODAL_ADDON } from '../../../../actions/modal';
import Translator from "../../../../requests/apa/Translator";
import { autobind } from 'packages/core/lib';
import { ColoredButton } from '../ColoredButton';
import { Tab } from '../Keyboard/Tab';
import { Button } from '../Button';
import Device from 'src/devices/device';
import Utils, { setInitialFocus } from '../../../../utils/Utils';
import { scrollIsElementVisible } from 'src/utils/Utils';
import Spinner from 'src/components/Spinner';
import { ID_NAME_PLAN_SELECTOR_ITEM } from 'src/components/Focus/constants';

export interface IPlanSelectorProps {
    /**
     * to add classname to main wrapper
     */
    className?: string;
    /**
     * callaback to fire when blue button is pressed
     */
    onBlueButton?: (activePlan: string) => void;
    /**
     * new data provides by metadata and asset service
     */
    cardData: any;
}

export interface IPlanSelectorState {
    activePlan: string;
    isLoading: boolean;
}

export class PlanSelector extends React.PureComponent<IPlanSelectorProps, IPlanSelectorState> {

    private keys: any;
    private navDirection: any;
    private nextAddonIsVisible: any;
    private planSelectorScrollLeftBeforeFocus: any;

    constructor(props: IPlanSelectorProps) {
        super(props);
        this.state = {
            activePlan: '',
            isLoading: true
        };
        this.keys = Device.getDevice() && Device.getDevice().getKeys() || null;
        this.navDirection = null;
        this.nextAddonIsVisible = true;
        this.planSelectorScrollLeftBeforeFocus = 0;
    }

    public async componentDidMount() {
        const { cardData } = this.props;

        if (cardData && cardData.length >= 0) {
            setTimeout(() => {
                setInitialFocus(`.itemPlanSelector0`, true);
            }, 1000);
        }

        document.removeEventListener("keydown", this.onKeyPress);
        document.addEventListener("keydown", this.onKeyPress);

        document.removeEventListener("sn:willfocus", this.onWillFocus);
        document.addEventListener("sn:willfocus", this.onWillFocus);
        this.setState({isLoading: false });

    }

    public componentWillUnmount(): void {
        document.removeEventListener("keydown", this.onKeyPress);
        document.removeEventListener("sn:willfocus", this.onWillFocus);
    }

    @autobind
    public handleFocus(planId: string, id:string): void {
        const el = document.getElementById(planId);

        if (el && typeof el.scrollIntoView === 'function') {
            console.log('NAV DIRECTION: ', this.navDirection);
            planId && this.moveScroll(planId);
        }

        this.setState({ activePlan: id });
    }

    @autobind
    public moveScroll(planId: string) {
        if (!this.nextAddonIsVisible) {
            const planSelectorContainer = document.getElementById('AAFPL');
            const addonCard = document.getElementById(`planSelectorItem${planId}`);

            if (addonCard && planSelectorContainer) {
                // Ancho del contenedor
                const addonCardStyle = addonCard.currentStyle || window.getComputedStyle(addonCard);
                let addonCardWidth = 204;

                let width = 0;
                let _marginLeft = 0;
                let _marginRight = 0;
                let _paddingLeft = 0;
                let _paddingRight = 0;
                let _borderLeft = 0;
                let _borderRight = 0;

                let margin = 0;
                let padding = 0;
                let border = 0;

                if (Utils.isNotNullOrNotUndefined(addonCardStyle)) {
                    if (Utils.isNotNullOrNotUndefined(addonCard.offsetWidth)) {
                        width = addonCard.offsetWidth;
                    }
                    else {
                        width = addonCard.width;
                    }

                    width = width + '';
                    width = width.replace('px', '');

                    _marginLeft = addonCardStyle.marginLeft;
                    if (Utils.isNullOrUndefined(_marginLeft)) {
                        _marginLeft = 0;
                    }
                    else {
                        _marginLeft = _marginLeft + '';
                        _marginLeft = _marginLeft.replace('px', '');
                    }

                    _marginRight = addonCardStyle.marginRight;
                    if (Utils.isNullOrUndefined(_marginRight)) {
                        _marginRight = 0;
                    }
                    else {
                        _marginRight = _marginRight + '';
                        _marginRight = _marginRight.replace('px', '');
                    }

                    margin = parseFloat(_marginLeft) + parseFloat(_marginRight);

                    _paddingLeft = addonCardStyle.paddingLeft;
                    if (Utils.isNullOrUndefined(_paddingLeft)) {
                        _paddingLeft = 0;
                    }
                    else {
                        _paddingLeft = _paddingLeft + '';
                        _paddingLeft = _paddingLeft.replace('px', '');
                    }

                    _paddingRight = addonCardStyle.paddingRight;

                    if (Utils.isNullOrUndefined(_paddingRight) || isNaN(_paddingRight)) {
                        _paddingRight = 0;
                    }
                    else {
                        _paddingRight = _paddingRight + '';
                        _paddingRight = _paddingRight.replace('px', '');
                    }

                    padding = parseFloat(_paddingLeft) + parseFloat(_paddingRight);

                    _borderLeft = addonCardStyle.borderLeftWidth;
                    if (Utils.isNullOrUndefined(_borderLeft)) {
                        _borderLeft = 0;
                    }
                    else {
                        _borderLeft = _borderLeft + '';
                        _borderLeft = _borderLeft.replace('px', '');
                    }

                    _borderRight = addonCardStyle.borderRightWidth;
                    if (Utils.isNullOrUndefined(_borderRight)) {
                        _borderRight = 0;
                    }
                    else {
                        _borderRight = _borderRight + '';
                        _borderRight = _borderRight.replace('px', '');
                    }

                    border = parseFloat(_borderLeft) + parseFloat(_borderRight);
                    addonCardWidth = parseFloat(width) + parseFloat(margin) + parseFloat(padding) + parseFloat(border);
                }

                if (isNaN(addonCardWidth) || addonCardWidth <= 0) {
                    addonCardWidth = 204;
                }
                switch (this.navDirection) {
                    default:
                        break;
                    case 'right':
                        planSelectorContainer.scrollLeft = this.planSelectorScrollLeftBeforeFocus + addonCardWidth;
                        break;
                    case 'left':
                        planSelectorContainer.scrollLeft = this.planSelectorScrollLeftBeforeFocus - addonCardWidth;
                        break;
                }
            }
        }
    }

    @autobind
    public onWillFocus(params: any) {
        console.log('PLSC Direction', params.detail.direction, 'id', params.target.id);
        if(params.target.id) {
            this.nextAddonIsVisible = scrollIsElementVisible('AAFPL', `planSelectorItem${params.target.id}`);
            this.navDirection = params.detail.direction;
            const planSelectorContainer = document.getElementById('AAFPL');
            // Scroll Inicial antes del focus
            if(planSelectorContainer) this.planSelectorScrollLeftBeforeFocus = planSelectorContainer?.scrollLeft;
        }
    }

    @autobind
    private onKeyPress(e: any): void {
        const { onBlueButton = () => { } } = this.props;
        const { activePlan } = this.state;
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch(currentKey){
            case "BLUE":
                activePlan &&
                    onBlueButton(activePlan);
                break;
            default:
        }
    }

    public render(): JSX.Element {
        const { className, cardData } = this.props;
        const { activePlan, isLoading } = this.state;
        const classNames = cls(PLAN_SELECTOR, className);

        return (
            <div className={classNames} id="AAFPL">
                {
                    cardData && cardData.map(({ imagenFondo_aaf, imagenLogo_aaf, TextImpuesto, TextoBotonIncluye3, TextoBotonSubscripcion1, TextoBotonSubscripcion2, TextoPromocion1, TextoPromocion2, TextoPromocion3, TextoTemporalidad, id, onPlanClick,buttonTextColorHex,buttonBGColorHex,cardColorRGB,isButtonVisible, price, currency, productType, family, offerid }: any, index: number) => {
                        return (
                            <PlanSelectorItem
                                onPlanClick={onPlanClick}
                                onPlanBlur={()=>this.handleFocus('',"")}
                                showMoreInfoButton={ activePlan === id}
                                id={`${ID_NAME_PLAN_SELECTOR_ITEM}${id}`}
                                onPlanFocus={()=>{this.handleFocus(`${ID_NAME_PLAN_SELECTOR_ITEM}${id}`, id)}}
                                key={id}
                                imagenLogo_aaf={imagenLogo_aaf}
                                buttonTextColorHex={buttonTextColorHex}
                                buttonBGColorHex={buttonBGColorHex}
                                cardColorRGB={cardColorRGB}
                                isButtonVisible = {isButtonVisible}
                                classFocusItem={index}
                                isLoading={isLoading}
                                imagenFondo_aaf={imagenFondo_aaf}
                                TextImpuesto= {TextImpuesto}
                                TextoBotonIncluye3= {TextoBotonIncluye3}
                                TextoBotonSubscripcion1= {TextoBotonSubscripcion1}
                                TextoBotonSubscripcion2= {TextoBotonSubscripcion2}
                                TextoPromocion1= {TextoPromocion1}
                                TextoPromocion2= {TextoPromocion2}
                                TextoPromocion3= {TextoPromocion3}
                                TextoTemporalidad= {TextoTemporalidad}
                                className= {className}
                                price= {price}
                                currency= {currency}
                                productType= {productType}
                                family= {family}
                                offerid= {offerid}
                        />
                        )
                    })
                }
            </div>
        );
    }
};

export interface ICardColor {
    r: number,
    g: number,
    b: number
}

export interface IPlanSelectorItemPropsNew {
    imagenFondo_aaf: string,
    imagenLogo_aaf: string,
    TextImpuesto: string,
    TextoBotonIncluye1?: string,
    TextoBotonIncluye2?: string,
    TextoBotonIncluye3: string,
    TextoBotonSubscripcion1: string,
    TextoBotonSubscripcion2: string,
    TextoPromocion1: string,
    TextoPromocion2: string,
    TextoPromocion3: string,
    TextoTemporalidad: string,
    id: string,
    onPlanClick?: React.EventHandler<any>
    buttonBGColorHex?: string;
    buttonTextColorHex?: string;
    cardColorRGB?: ICardColor,
    onPlanFocus?: React.EventHandler<any>;
    onPlanBlur?: React.EventHandler<any>;
    showMoreInfoButton?: boolean;
    isButtonVisible: boolean,
    classFocusItem: number,
    isLoading: boolean,
    className?: string,
    price: string,
    currency: string,
    productType: string,
    family: string,
    offerid: number
}

const getPlanSelectorItemStyle = (price: string, bonus: string): object => {
    if (price === '' && bonus.length > 40) {
        return {
            marginTop: '0px'
        }
    }
    else {
        return {
            marginTop: '1px',
            paddingLeft: '12px',
            paddingRight: '12px'
        }
    }
}

const getPlanSelectorCharacterStyleByPromotion = (labelPromotion: string): object => {
    if (labelPromotion.length > 25 && labelPromotion.length <= 54) {
        return {
            fontSize: '14px'
        }
    }
    return {
        fontSize: '16px'
    }
}

const getPlanSelectorCharacterStyleByButtonInludes = (labelButtonIncludes: string): object => {
    if (labelButtonIncludes.length > 25 && labelButtonIncludes.length <= 52) {
        return {
            fontSize: '14px',
            marginLeft: '4px'
        }
    }
    return {
        fontSize: '20px',
        marginLeft: '4px'
    }
}

const withEllipsis = (text: string, maxLength: number): string => {
    if (text && text.length > maxLength) {
        return text.slice(0, maxLength - 3).concat("...");
    }
    return text
}

export const PlanSelectorItem: React.StatelessComponent<IPlanSelectorItemPropsNew> = ({
        imagenFondo_aaf,
        imagenLogo_aaf,
        TextImpuesto,
        TextoBotonIncluye3,
        TextoBotonSubscripcion1,
        TextoBotonSubscripcion2,
        TextoPromocion1,
        TextoPromocion2,
        TextoPromocion3,
        TextoTemporalidad,
        id,
        buttonBGColorHex = '#000',
        buttonTextColorHex = '#FFF',
        cardColorRGB: { r = 0, g = 0, b = 0 } = {},
        className,
        onPlanClick = () => { },
        onPlanFocus,
        onPlanBlur,
        showMoreInfoButton,
        isButtonVisible,
        classFocusItem,
        isLoading,
        price,
        currency,
        productType,
        family,
        offerid
    }) => {

    if (isLoading) {
        return <Spinner className='payment' loadingMessage="" />;
    }

    const modalType = Utils.modalType();
    const keyOneTextoPromocionInLive = Translator.get(`ContratacionCanal_Tarjeta_TextoPromocion1_${productType}`, '');
    const keyTwoTextoPromocionInLive = Translator.get(`ContratacionCanal_Tarjeta_TextoPromocion1_${offerid}`, '');
    const keyThreeTextoPromocionInLive = Translator.get(`ContratacionCanal_Tarjeta_TextoPromocion1_${family}`, '');
    const multiKeyPromotion = keyOneTextoPromocionInLive !== '' ? keyOneTextoPromocionInLive : keyTwoTextoPromocionInLive !== '' ? keyTwoTextoPromocionInLive : keyThreeTextoPromocionInLive;
    const TextoPromocionInLive = multiKeyPromotion;
    let isLivePlanSelector = false;
    const handleMouseEnter = (e: any) => {
        Utils.handleMouseEnter(e)
     }

    if (modalType === MODAL_ADDON) {
        isLivePlanSelector = true;
    }

    return (
        <div
            id={`planSelectorItem${id}`}
            className={cls(PLAN_SELECTOR_ITEM, className)}
            onFocus={onPlanFocus}
            onBlur={onPlanBlur}
            onClick={() => { onPlanClick(id) }}
            onMouseEnter={() => handleMouseEnter(id)}
        >
            <a
                href="javascript:void(0)"
                className={cls(PLAN_SELECTOR_ITEM_CARD, 'focusable', `itemPlanSelector${classFocusItem}, outline-focus`)}
                style={{ backgroundImage: `url("${imagenFondo_aaf}")` }}
                id={id}
            >
                <div className={PLAN_SELECTOR_ITEM_CARD_CONTENT}>
                    <div className={PLAN_SELECTOR_ITEM_CARD_CONTENT_PROVIDER_LOGO} style={{
                        textAlign: 'center'
                    }}>
                        <img src={imagenLogo_aaf} alt={`${imagenLogo_aaf} logo`} />
                    </div>
                    <div
                        className={PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION}
                    >
                        <div className={PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PRICE_FREQUENCY}>
                            {
                                <span className={PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_CURRRENCY}>
                                    {price &&currency}
                                </span>
                            }
                            {
                                <span className={PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PRICE}>
                                    {price && price}
                                </span>
                            }
                            {
                                <span className={PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PERIODICITY}>
                                    {price && TextoTemporalidad}
                                </span>
                            }
                        </div>
                        <div className={PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PRICE_TAXES}>
                            {
                                <span className={PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_TAX}>
                                    {price && TextImpuesto}
                                </span>
                            }
                        </div>
                        <div
                            className={isLivePlanSelector ? `${PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_IN_MODAL_ADD_ON}` : `${PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD} ${TextoPromocion1.length > 10 ? '-text-overflow' : ''}`}
                            style={getPlanSelectorCharacterStyleByPromotion(TextoPromocion1)}
                        >
                            {
                                isLivePlanSelector
                                    ? (
                                        <span className={`${PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_PROMOTION_IN_MODAL_ADD_ON}`}>
                                            {TextoPromocionInLive}
                                        </span>
                                    ) : (
                                        <div>
                                            <span className={`${PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_PROMOTION1}`}>
                                                {withEllipsis(TextoPromocion1, 23)}
                                            </span>
                                            <span className={`${PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_PROMOTION2}`}>
                                                {withEllipsis(TextoPromocion2, 23)}
                                            </span>
                                            <span className={`${PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_PROMOTION3}`}>
                                                {withEllipsis(TextoPromocion3, 21)}
                                            </span>
                                        </div>
                                    )
                            }
                        </div>
                        {
                            isButtonVisible &&
                            <div style={getPlanSelectorItemStyle(price, TextoBotonSubscripcion1)}>
                                <Button
                                    style={{
                                        backgroundColor: buttonBGColorHex,
                                        color: buttonTextColorHex
                                    }}
                                    type="button"
                                >
                                    <span> {TextoBotonSubscripcion1} </span>
                                    <span> {TextoBotonSubscripcion2} </span>
                                </Button>
                            </div>
                        }
                    </div>
                </div>
            </a>

            <div className={PLAN_SELECTOR_ITEM_MORE_INFO}>
                <Tab className={cls(PLAN_SELECTOR_ITEM_MORE_INFO_TAB, {
                    [PLAN_SELECTOR_ITEM_MORE_INFO_TAB_ACTIVE]: !!showMoreInfoButton,
                    [PLAN_SELECTOR_ITEM_MORE_INFO_TAB_DEACTIVATE]: !showMoreInfoButton
                })}>
                    <div className='container-button-include'>
                        <ColoredButton
                            color="blue"
                            classSizeHotkey="large"
                            className={'access_option_button_blue'}
                            style={getPlanSelectorCharacterStyleByButtonInludes(TextoBotonIncluye3)}
                        >
                            <div className='button-include'>
                                {`${TextoBotonIncluye3}`}
                            </div>
                        </ColoredButton>
                    </div>
                </Tab>
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/packages/components/lib/PlanSelector/index.tsx